import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PhoneSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PhoneSVG;
